module.exports = __webpack_public_path__ + "static/media/wrong-number-icon.d36be5af.png";